<template>
  <section>
    <v-layout row wrap>
      <v-layout class="mt-5 mb-4" justify-end >
        <v-flex xs9 class="text-xs-left">
          <div class="title-secondary">Registro de evaluaciones</div>
        </v-flex>
        <v-flex xs2 class="text-xs-left">
          <v-btn color="primary" @click="volver()"><v-icon>arrow_back</v-icon>Volver</v-btn>
        </v-flex>
      </v-layout>

      <v-flex xs10 offset-xs1>
        <v-flex class="ml-0 " >
                    <v-card-title>
                      <v-spacer></v-spacer>
                      <v-text-field
                        append-icon="search"
                        label="Buscador"
                        single-line
                        hide-details
                        v-model="search"
                      ></v-text-field>
                    </v-card-title>
                    <v-flex mx-5>
                    <v-data-table 
                        v-bind:headers="headers"
                        v-bind:items="members"
                        v-bind:search="search"
                        rows-per-page-text = "Filas por Pagina"
                        no-data-text="No hay Pruebas de Miembros"
                      >
                      <template slot="items" slot-scope="props">
                        <td class="py-2"> <v-avatar><img height="40" :src="props.item.user.avatar"/></v-avatar></td>
                        <td class="text-xs-center primary--text body-1">{{ props.item.user.nombre}} {{props.item.user.apellido }}</td>
                        <td class="text-xs-center">{{ props.item.user.email }}</td>
                        <td class="text-xs-center">{{ props.item.user.rut}}</td>
                        <td class="text-xs-center">
                          
                          <v-switch
                            v-model="membersAux[props.index].isAyudante"
                            label="Ayudante"
                            color="accent"
                            :value="true"
                            hide-details
                            @change="actualizarAyudante(props.index, props.item.id)"
                          ></v-switch>
                          
                        </td>
                        <td class="text-xs-center">
                           <v-tooltip bottom>
                             <v-btn  slot="activator" icon color="red" class="white--text"  @click="showDialogDeleteElement(props.item.id)" >
                            <v-icon>delete_forever</v-icon>
                          </v-btn>
                              <span>Eliminar del curso</span>
                          </v-tooltip>
                          
                        </td>
                      </template>
                      <template slot="pageText" slot-scope="{ pageStart, pageStop }">
                        Desde {{ pageStart }} a {{ pageStop }}
                      </template>
                    </v-data-table>
                    </v-flex>
                  
                </v-flex>
        
        
      </v-flex>
    </v-layout>

    <v-layout row wrap class="mt-5">
      <v-flex xs10 offset-xs1>
        <v-layout row wrap>
          
        </v-layout>
      </v-flex>
    </v-layout>

<v-dialog v-model="dialogDeleteElement"  max-width="500px" >
  <v-card class=" ma-0">
      <v-card-title class="balck--text center headline">¿Estas seguro que lo deseas <span class="white--text">.</span><span class="red--text"> Eliminar</span>?</v-card-title>
    <v-form  >
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn  color="red" outline @click.native="dialogDeleteElement = false" >Cancelar</v-btn>
        <v-btn class="white--text" color="red"  @click="deleteMember()" >Eliminar</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</v-dialog>

  <v-snackbar
      :timeout="timeout"
      :color="colorSnackbar"
      v-model="snackbar"
    >
    <v-icon dark>check_circle</v-icon>
      {{ textSnackbar }}
      <v-btn dark flat @click.native="snackbar = false">X</v-btn>
  </v-snackbar>

  </section>
</template>

<script>
import { courceService } from '@/services/Cource.service'
// import { getUsersInCourseService } from '@/services/Miembro/GetUsersInCourses.service'
import { memberService } from '@/services/Miembro/member.service'
import { changeMemberType } from '@/services/Miembro/ChangeMemberType.service'
import { getParticipantesCourse } from '@/services/Miembro/GetParticipantesCourse.service'

export default {
  data () {
    return {
      idCurso: 0,
      dialogDeleteElement: false,
      curso: 0,
      search: '',
      pagination: {},
      members: [],
      snackbar: false,
      colorSnackbar: '',
      timeout: 6000,
      textSnackbar: '',
      headers: [
        { text: '', align: '', value: '' },
        { text: 'Nombre', align: 'center', value: 'nombre' },
        { text: 'e-Mail', align: 'center', value: 'correo' },
        { text: 'Rut', align: 'center', value: 'rut' },
        { text: 'Cambiar nivel', align: 'center', value: 'nivel' },
        { text: 'Desvincular', align: 'center', value: 'desvincular' }
      ],
      isAyudante: false,
      membersAux: [
      ],
      elementDelete: 0
    }
  },
  mounted () {
    let vm = this
    vm.idCurso = vm.$route.params.id
    vm.loadCurso()
    vm.loadMemberGet()
  },
  methods: {
    loadCurso () {
      let vm = this
      courceService.getById(vm.idCurso).then(data => {
        vm.curso = data.body
      })
    },
    loadMemberGet () {
      let vm = this
      var nuevo = {
        id: 0,
        isAyudante: false
      }
      getParticipantesCourse.getById(vm.idCurso).then(data => {
        vm.members = data.body
        for (var i in data.body) {
          nuevo.id = data.body[i].user.id
          if (data.body[i].type_user_id === 1) {
            nuevo.isAyudante = false
            nuevo.type_user = 1
          } else if (data.body[i].type_user_id === 3) {
            nuevo.isAyudante = true
            nuevo.type_user = 3
          }
          vm.membersAux.push(nuevo)
          nuevo = {}
        }
      })
    },
    showDialogDeleteElement (id) {
      let vm = this
      vm.elementDelete = id
      vm.dialogDeleteElement = true
    },
    deleteMember () {
      let vm = this
      memberService.destroy(vm.elementDelete).then(data => {
        vm.mensajeToast('success', true, 'Miembro eliminado con exito')
        vm.members = data.body
        vm.dialogDeleteElement = false
      }, response => {
        vm.mensajeToast('error', true, 'Error al eliminar Miembro')
        vm.dialogDeleteElement = false
      })
    },
    actualizarAyudante (index, id) {
      let vm = this
      if (vm.membersAux[index].isAyudante) {
        vm.membersAux[index].type_user = 3
      } else {
        vm.membersAux[index].type_user = 1
      }
      var model = {
        type_user_id: vm.membersAux[index].type_user
      }
      changeMemberType.update(id, model).then(data => {
      })
    },
    volver () {
      this.$router.back()
    },
    mensajeToast (color, snack, texto) {
      let vm = this
      vm.colorSnackbar = color
      vm.snackbar = snack
      vm.textSnackbar = texto
    }
  }
}
</script>

<style scoped>
 .title-secondary {
    letter-spacing: 2.5px;
    color: #e64a19;
    font-size: 25px;
    font-weight: 500;
  }
.circulo {
     width: 60px;
     height: 60px;
     -moz-border-radius: 50%;
     -webkit-border-radius: 50%;
     border-radius: 50%;
     background: white;
}

.bordes {
  border-radius: 20px 20px 20px 20px;
-moz-border-radius: 20px 20px 20px 20px;
-webkit-border-radius: 20px 20px 20px 20px;
border: 0px solid #000000;
}
.enlace {
  text-decoration:none;
}
</style>


// WEBPACK FOOTER //
// src/components/Calificacion/ShowMembersInCources.vue